import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import styled from 'styled-components';
import FiterPagination from './FiterPagination';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const limit = 100;
export default function WhatsappList(props) {
  const { getAbstentions, areaId, monthFilter, institution, areasList } = props;
  const [usersList, setUsersList] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [mensage, setMensage] = useState('');

  useEffect(() => {
    async function fetchData() {
      setLoaded(false);
      const abstentionsList = await getAbstentions({
        institution,
        monthFilter,
        page,
        areasFilter: areasList
      });
      const { data, count } = abstentionsList;
      setPages(Math.ceil(count / limit));
      setUsersList(data);
      setLoaded(true);
    }
    fetchData();
  }, [areaId, areasList, getAbstentions, institution, monthFilter, page]);

  function handleSetMensage(text) {
    setMensage(String(text).replace(/\n/g, '%0D'));
  }
  function getWhatsappLink(phone, fullname) {
    const firtstName = String(fullname)
      .split(' ')
      .slice(0, 1)
      .join(' ');
    const textMensage = String(mensage).replace('{nome}', firtstName);
    const fullMensage = `https://api.whatsapp.com/send?phone=55${phone}&text=${textMensage}`;
    return fullMensage;
  }

  return (
    <>
      {!loaded ? (
        <>
          <div />
        </>
      ) : (
        <Container>
          <TextField
            onChange={e => handleSetMensage(e.target.value)}
            multiline
            placeholder="Texto"
          />
          <Table responsive bordered style={{ width: `${100}%` }}>
            <thead>
              <tr>
                <th className="name-header">Nome</th>
                <th className="name-header">Área</th>
              </tr>
            </thead>
            <tbody>
              {usersList.map(user => (
                <tr>
                  <td>
                    {user.name}{' '}
                    {user.phone ? (
                      <a
                        target="_blank"
                        href={getWhatsappLink(user.phone, user.name)}
                      >
                        {user.phone}
                      </a>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{user.areaLabel}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <FiterPagination pages={pages} page={page} setPage={setPage} />
        </Container>
      )}
    </>
  );
}
